import Axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import Spinner from "../../../components/Spinner/Spinner";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import * as actions from "../../../store/actions/index";
import CouponCard from "./couponCard";

class AddCoupon extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEditSubmit = this.handleEditSubmit.bind(this);
    this.handleDeleteCoupon = this.handleDeleteCoupon.bind(this);

    this.state = {
      couponName: "",
      minOrder: "",
      maxDiscount: "",
      discountPercentage: "",
      reusable: "",
      expiryDate: "",
      couponId: null,
      coupon: null,
      coupons: this.props.coupons,
    };
  }

  componentDidMount() {
    this.props.onFetchCoupon();
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    let {
      couponName,
      minOrder,
      maxDiscount,
      discountPercentage,
      reusable,
      expiryDate,
    } = this.state;
    let newCoupon = {
      couponName: couponName.toUpperCase(),
      minOrder: parseInt(minOrder), //compulsory
      maxDiscount: maxDiscount ? parseInt(maxDiscount) : 0,
      discountPercentage: discountPercentage ? parseInt(discountPercentage) : 0,
      reusable: reusable == "true" ? true : false,
      expiryDate: expiryDate,
    };
    this.props.onAddCoupon(newCoupon);
  }

  handleEditSubmit(e, editedCoupon) {
    e.preventDefault();
    let coupon = editedCoupon;
    if (coupon) {
      coupon["discountPercentage"] = parseInt(coupon["discountPercentage"]);
      coupon["maxDiscount"] = parseInt(coupon["maxDiscount"]);
      coupon["couponName"] = coupon["couponName"].toUpperCase();
      coupon["minOrder"] = parseInt(coupon["minOrder"]);
      coupon["reusable"] =
        coupon["reusable"] == "true" || coupon["reusable"] == true
          ? true
          : false;
      this.props.onEditCoupon(coupon, this.props.coupons);
    } else {
      alert("coupon is null.");
    }
  }

  handleDeleteCoupon(e, couponId) {
    e.preventDefault();
    this.props.onDeleteCoupon(couponId);
  }

  render() {
    if (this.props.loading) {
      return <Spinner />;
    }
    let coupons = this.props.coupons;
    let couponList =
      coupons &&
      coupons.map((coupon, index) => (
        <CouponCard
          key={index}
          coupon={coupon}
          id={coupon.couponId}
          handleEditSubmit={(e, editedCoupon) =>
            this.handleEditSubmit(e, editedCoupon)
          }
          handleDeleteCoupon={this.handleDeleteCoupon}
          couponBtnLoading={this.props.couponBtnLoading}
          deleteBtnLoading={this.props.deleteBtnLoading}
          // isAdmin={this.props.isAdmin}
        />
      ));

    return (
      <div className="container mt-2">
        <h3 className="text-center">Coupon Management</h3>
        <hr />
        <form onSubmit={this.handleSubmit}>
          <div className="row">
            <div className="col-md-4 m-1">
              <input
                name="couponName"
                type="text"
                className="form-control"
                placeholder="Enter Coupon Name"
                onChange={this.handleChange}
                value={this.state.couponName}
                required
              />
            </div>
            <div className="col-md-2 m-1">
              <div className="input-group mb-2">
                <div className="input-group-prepend">
                  <div className="input-group-text">₹</div>
                </div>
                <input
                  name="minOrder"
                  type="number"
                  className="form-control"
                  placeholder="Min Order"
                  onChange={this.handleChange}
                  value={this.state.minOrder}
                  required
                />
              </div>
            </div>
            <div className="col-md-3 m-1">
              <div className="input-group mb-2">
                <div className="input-group-prepend">
                  <div className="input-group-text">₹</div>
                </div>
                <input
                  name="maxDiscount"
                  type="number"
                  className="form-control"
                  placeholder="Max discount"
                  onChange={this.handleChange}
                  value={this.state.maxDiscount}
                  required
                />
              </div>
            </div>
            <div className="col-md-2 m-1">
              <div className="input-group mb-2">
                <div className="input-group-prepend">
                  <div className="input-group-text">%</div>
                </div>
                <input
                  name="discountPercentage"
                  type="number"
                  className="form-control"
                  placeholder="% discount"
                  onChange={this.handleChange}
                  value={this.state.discountPercentage}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <legend className="col-form-label col-sm-1 mt-3">Reusable:</legend>

            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="reusable"
                id="inlineRadio1"
                onChange={this.handleChange}
                value={true}
              />
              <label className="form-check-label" htmlFor="inlineRadio1">
                Yes
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="reusable"
                onChange={this.handleChange}
                id="inlineRadio2"
                value={false}
              />
              <label className="form-check-label" htmlFor="inlineRadio2">
                No
              </label>
            </div>

            <div className="col-md-3 m-3">
              <label htmlFor="expiryDate" className="mt-1">
                Expiry Date:{" "}
              </label>
              <input
                type="date"
                className="form-check-input ml-3"
                id="expiryDate"
                name="expiryDate"
                onChange={this.handleChange}
                required
              />
            </div>
            <div className="col m-1">
              <button
                type="submit"
                style={{ marginTop: "0.7rem" }}
                className="btn btn-info "
                // onClick={this.handleSubmit}
                disabled={this.props.couponBtnLoading}
              >
                {this.props.couponBtnLoading ? "Saving" : "Add"}
              </button>
            </div>
          </div>
        </form>
        <hr />
        <div className="row mt-2">{couponList}</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    coupons: state.coupons.coupons,
    loading: state.coupons.loading,
    couponBtnLoading: state.coupons.couponBtnLoading,
    deleteBtnLoading: state.coupons.deleteBtnLoading,
    // isAdmin: state.auth.admin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAddCoupon: (newCoupon) => dispatch(actions.onAddCoupon(newCoupon)),
    onFetchCoupon: () => dispatch(actions.onFetchCoupon()),
    onEditCoupon: (editedCoupon, oldCouponArray) =>
      dispatch(actions.onEditCoupon(editedCoupon, oldCouponArray)),
    onDeleteCoupon: (couponId) => dispatch(actions.onDeleteCoupon(couponId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(AddCoupon, Axios));
